import {
  GET_ALL_E_TENDER_NOTIFICATION_FAILURE,
  GET_ALL_E_TENDER_NOTIFICATION_REQUEST,
  GET_ALL_E_TENDER_NOTIFICATION_SUCCESS,
} from "./actionTypes";

const initialState = {
  ISlOADING: false,
  E_TENDER_WEBSITE_NOTIFICATIONS: {},
  ISFAILURE: false,
};

export default function E_TENDER_NotificationReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case GET_ALL_E_TENDER_NOTIFICATION_REQUEST:
      return { ...state, ISlOADING: true };
    case GET_ALL_E_TENDER_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        E_TENDER_WEBSITE_NOTIFICATIONS: payload.data,
        ISlOADING: false,
      };
    }
    case GET_ALL_E_TENDER_NOTIFICATION_FAILURE:
      return { ...state, ISFAILURE: true, ISlOADING: false };
    default:
      return state;
  }
}
